<template>
	<div class="home">
		<div class="welcome-section">
			<HomeSlider :sliders="slides"></HomeSlider>
		</div>
		<div class="intro-section">
			<HomeIntroduction />
		</div>
	</div>
</template>

<script>
import HomeSlider from '@/components/HomeSlider'
import HomeIntroduction from '@/components/HomeIntroduction'
import { sliderData } from '@/shared/slider-provider'
export default {
	name: 'home',
	components: { HomeSlider, HomeIntroduction },
	computed: {
		slides() {
			return sliderData
		},
	},
	metaInfo: {
		meta: [
			{
				itemprop: 'name',
				content:
					'Usługi księgowe dla firm. Sulechów - Biuro Rachunkowe Joanna Macikowska',
			},
			{
				itemprop: 'description',
				content:
					'Sulechów Biuro Rachunkowe - Kontakt: tel. 690 00 11 53. Oferujemy szeroki zakres usług obsługi księgowej. Podchodzimy indywidualnie do klientów',
			},
			{
				itemprop: 'image',
				content: 'https://macikowska.pl/site_img.jpeg',
			},
			{
				property: 'og:title',
				content: 'Biuro Rachunkowe Joanna Macikowska',
			},
			{ property: 'og:site_name', content: 'macikowska.pl' },
			// The list of types is available here: http://ogp.me/#types
			{ property: 'og:type', content: 'website' },
			// Should the the same as your canonical link, see below.
			{
				property: 'og:url',
				content: 'https://www.macikowska.pl',
			},
			{
				property: 'og:image',
				content: 'https://www.macikowska.pl/site_img.jpeg',
			},
			// Often the same as your meta description, but not always.
			{
				property: 'og:description',
				content: 'Obłsuga księgowa firm na najwyższym poziomie',
			},
		],
	},
}
</script>

<style lang="scss">
.home {
	position: absolute;
	overflow: hidden;
	min-height: 100vh;
	top: 0;
	@include d-flex-column;
}
</style>
